import React from 'react';
import { Type } from 'lucide-react';

const TextEditor = ({ 
  label, 
  value, 
  onChange, 
  type = 'text', 
  placeholder = '', 
  multiline = false,
  rows = 3,
  maxLength,
  helpText 
}) => {
  const InputComponent = multiline ? 'textarea' : 'input';
  
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Type className="h-4 w-4 text-gray-500" />
        <label className="block text-sm font-bold text-gray-700 font-inter">
          {label}
        </label>
        {maxLength && (
          <span className="text-xs text-gray-500">
            ({value?.length || 0}/{maxLength})
          </span>
        )}
      </div>
      
      <InputComponent
        type={multiline ? undefined : type}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={multiline ? rows : undefined}
        maxLength={maxLength}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent font-inter resize-none"
      />
      
      {helpText && (
        <p className="text-xs text-gray-600 font-inter">{helpText}</p>
      )}
    </div>
  );
};

export default TextEditor;